import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {startWith, takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrls: ['./slide-toggle.component.scss']
})
export class SlideToggleComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() control: FormControl;
  @Input() header: string;
  @Input() trueValue: any = true;
  @Input() falseValue: any = false;

  slideControl: FormControl;

  constructor(
    private fb: FormBuilder,
  ) {
    this.slideControl = fb.control(false);
  }

  ngOnInit(): void {
    this.slideControl.setValue(this.control.value === this.trueValue);
    this.slideControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((val: boolean) => {
        if (val) {
          this.control.setValue(this.trueValue);
        } else {
          this.control.setValue(this.falseValue);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
